import React, { useRef, useState } from "react";
import { useTranslation, Trans } from "./configure-i18n";

export const I18nStorybookChangeLanguage = (): JSX.Element => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang: string): void => {
    i18n.changeLanguage(lang);
  };

  return (
    <div>
      <div>Кнопки переключения языка:</div>
      <div>
        <button
          onClick={(): void => {
            changeLanguage("ru-RU");
          }}
          type="button"
        >
          ru
        </button>
        <button
          onClick={(): void => {
            changeLanguage("pl-PL");
          }}
          type="button"
        >
          pl
        </button>
        <button
          onClick={(): void => {
            changeLanguage("en-US");
          }}
          type="button"
        >
          en
        </button>
        <button
          onClick={(): void => {
            changeLanguage("de-DE");
          }}
          type="button"
        >
          de
        </button>
        <button
          onClick={(): void => {
            changeLanguage("es-ES");
          }}
          type="button"
        >
          es
        </button>
        <button
          onClick={(): void => {
            changeLanguage("et-EE");
          }}
          type="button"
        >
          et
        </button>
        <button
          onClick={(): void => {
            changeLanguage("uk-UA");
          }}
          type="button"
        >
          uk
        </button>
        <button
          onClick={(): void => {
            changeLanguage("az-AZ");
          }}
          type="button"
        >
          az
        </button>
        <button
          onClick={(): void => {
            changeLanguage("uz-UZ");
          }}
          type="button"
        >
          uz
        </button>
        <button
          onClick={(): void => {
            changeLanguage("tr-TR");
          }}
          type="button"
        >
          tr
        </button>
      </div>
    </div>
  );
};

export default I18nStorybookChangeLanguage;
